
import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/note/query/', 'Notes');

tbl.add(new Xtc('title', 'Title'))
// tbl.add(new Xtc('description', 'Description').hidden().renderSlot('description'))
tbl.add(new Xtc('date', 'Date').renderSlot('time'))
tbl.add(new Xtc('matter', 'Matter').renderSlot('matter'))
tbl.add(new Xtc('contact', 'Contact').renderSlot('contact'))
tbl.add(new Xtc('notifications', 'Notifications').renderSlot('notifications'))
tbl.add(new Xtc('recorded_time', 'Recorded Time (hour)').renderSlot('record'))
tbl.add(new Xtc('creator', 'Author').renderSlot('author'))
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

